<template>
  <ValidationObserver ref="observer">
  <b-card>
    <b-row class="mb-3">
      <b-col>
        <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="user name"
          >
        <c-input
          inputType="text"
          inputId="username"
          lableText="User Name *"
          v-model="access.userName"
        />
        <span class="validate-error cstm-err">{{ errors[0] }}</span>
          </ValidationProvider>
      </b-col>
      <b-col>
        <ValidationProvider
            rules="required|min:6"
            v-slot="{ errors }"
            name="password"
            ref="confirmation"
          >
        <c-input
          inputType="password"
          inputId="pwd"
          lableText="Password *"
          v-model="access.password"
        />
        <span class="validate-error cstm-err">{{ errors[0] }}</span>
          </ValidationProvider>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <ValidationProvider
        rules="required|confirm:confirmation"
            v-slot="{ errors }"
            name="confirm password"
          >
        <c-input
          inputType="password"
          inputId="pwd"
          lableText="Confirm Password *"
          v-model="access.confirmpassword"
        />
        <span class="validate-error cstm-err">{{ errors[0] }}</span>
          </ValidationProvider>
      </b-col>
      <b-col>
        <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="category"
          >
        <eb-select
          type="text"
          v-if="!isEdit"
          v-model="access.category"
          :options="categoryOptions"
          label="label"
          placeholder="Select Category *"
        ></eb-select>
        <span class="validate-error cstm-err">{{ errors[0] }}</span>
          </ValidationProvider>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col>
        <b-col>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="role"
          >
          <multiselect
            v-model="access.role"
            v-if="!isEdit"
            tag-placeholder="Add this as new role"
            placeholder="Select Role *"
            label="name"
            :selected="selectedRole"
            track-by="name"
            :options="roleOptions"
            :multiple="true"
            :taggable="false"
            :open-direction="'bottom'"
          ></multiselect>
          <span class="validate-error cstm-err">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-col>
      <b-col md="6" v-if="$userRole == 'Tenant'">
        <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="org access level"
          >
        <eb-select
          type="text"
          v-if="!isEdit"
          v-model="access.orgAccessLevel"
          :options="orgAccessOptions"
          label="label"
          placeholder="Select org Access Level *"
        ></eb-select>
        <span class="validate-error cstm-err">{{ errors[0] }}</span>
          </ValidationProvider>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col
        md="6"
        v-if="
          access.orgAccessLevel && access.orgAccessLevel.value === 'Limited'
        "
      >
        <multiselect
          v-model="access.orgAccessList"
          v-if="!isEdit"
          tag-placeholder="Add this as new org Access"
          placeholder="Select org Access List"
          label="userName"
          track-by="userName"
          :options="orgAccessListOptions"
          :multiple="true"
          :taggable="false"
          :open-direction="'top'"
        ></multiselect>
      </b-col>
    </b-row>

    <!-- <b-row class="mt-1">
      <b-col md="6">
        <eb-select
          type="text"
          v-model="access.geoAccessLevel"
          :options="geoAccessOptions"
          label="label"
          placeholder="Select geo Access Level"
        ></eb-select>
      </b-col>
      <b-col md="6">
        <multiselect
          v-model="access.geoAccessList"
          tag-placeholder="Add this as new geo Access"
          placeholder="Select geo Access List"
          label="label"
          track-by="label"
          :options="geoAccessListOptions"
          :multiple="true"
          :taggable="false"
        ></multiselect>
      </b-col>
    </b-row>-->

    <slot name="footer-button" :data="access"></slot>
  </b-card>
</ValidationObserver>
</template>
<script>
import {
  ValidationProvider,
  ValidationObserver,
  Validator
} from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";

export default {
  name: "AcessStepper",
  props: {
    userInfo: {
      type: Object,
      required: false,
      default: () => ({
        access: {
          userName: "",
        },
      }),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedRole: "",
      access: {
        category: "",
        orgAccessLevel: "",
        geoAccessLevel: "",
        geoAccessList: null,
        role: null,
        orgAccessList: null,
        userName: "",
        password: "",
        confirmpassword: "",
        
      },
    };
  },
  components: {
    cInput,
    cTelInput,
    ebSelect,
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    categoryOptions() {
      return [
        { label: "DELIVERY_AGENT", value: "DELIVERY_AGENT" },
        { label: "DRIVER", value: "DRIVER" },
        { label: "DOCTOR", value: "DOCTOR" },
        { label: "PHYSIOTHERAPIST", value: "PHYSIOTHERAPIST" },
        {
          label: "CollectionAgent_Diagnostic",
          value: "CollectionAgent_Diagnostic",
        },
        { label: "CLEANING", value: "CLEANING" },
        { label: "COOKING", value: "COOKING" },
        { label: "BABY_SITTING", value: "BABY_SITTING" },
        { label: "ELDERLY_CARE", value: "ELDERLY_CARE" },
        { label: "PLUMBER", value: "PLUMBER" },
        { label: "CARPENTER", value: "CARPENTER" },
        { label: "PEST_CONTROL", value: "PEST_CONTROL" },
        { label: "APPLIANCE_REPAIR", value: "APPLIANCE_REPAIR" },
        { label: "SALOON_SPA", value: "SALOON_SPA" },
        { label: "ELECTRICIAN", value: "ELECTRICIAN" },
        { label: "PAINTER", value: "PAINTER" },
      ];
    },
    orgAccessOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
        {
          label: "Limited",
          value: "Limited",
        },
      ];
    },
    geoAccessOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
      ];
    },
    geoAccessListOptions() {
      return [
        {
          label: "Global",
          value: "Global",
        },
      ];
    },

    roleOptions() {
      let data = this.$store.getters["role/GetRoleList"];
      data = data.filter(
        (obj) =>
          obj.name !== "DELIVERY_AGENT" &&
          obj.name !== "Admin" &&
          obj.name !== "DRIVER" &&
          obj.name !== "DOCTOR" &&
          obj.name !== "PHYSIOTHERAPIST" &&
          obj.name !== "CollectionAgent_Diagnostic" &&
          obj.name !== "CLEANING" &&
          obj.name !== "COOKING" &&
          obj.name !== "BABY_SITTING" &&
          obj.name !== "ELDERLY_CARE" &&
          obj.name !== "PLUMBER" &&
          obj.name !== "CARPENTER" &&
          obj.name !== "PEST_CONTROL" &&
          obj.name !== "APPLIANCE_REPAIR" &&
          obj.name !== "SALOON_SPA" &&
          obj.name !== "ELECTRICIAN"
      );
      return data;
    },
    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (obj.category === "OFFICE") {
            let arrayObj = {
              _id: obj._id,
              userName: obj.authentication.userName,
              email: obj.authentication.email,
              phone: obj.authentication.phone,
              password: "",
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
  },
  methods: {
    isValid() {
      const isValid = this.$refs.observer.validate();
      this.$emit("isValid", isValid);
      return isValid;
    },
  },
  async mounted() {
    Validator.extend(
      "confirm",
      (value, [otherValue]) => {
        return value == this.access.password;
      },
      {
        hasTarget: true,
      }
    );
    setTimeout(() => {
      this.access = {
        category: "",
        userName: this.userInfo.userName || "",
      };
    }, 200);
    const partnerListData = this.$store.getters["partner/getPartnersList"];
    if (!partnerListData || !partnerListData.length)
      await this.$store.dispatch("partner/officeList").then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        }
      });
    await this.$store.dispatch("role/fetchRoles");
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: var(--primary);
  color: white;
}
.sqanswer {
  margin-top: -12px !important;
}
.card {
  border-width: 1160px;
  border-radius: 16px;
}
.cstm-err{
  color: red;
}
</style>
